import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import { OutcomesFormProps } from '~pages/Dialler/ConnectDialler/VoiceView/OutcomeCapture';

const OutcomesForm = ({ formSubmitting }: OutcomesFormProps) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  return (
    <>
      <Grid item xs={12}>
        <Controller
          name='nmi'
          control={control}
          defaultValue={''}
          render={({ field }) => (
            <TextField
              {...field}
              fullWidth
              variant='outlined'
              id='nmi'
              label='NMI'
              disabled={formSubmitting}
              error={Boolean(errors.nmi)}
              helperText={errors.nmi?.message as string | undefined}
            />
          )}
        />
      </Grid>

      <Grid item xs={12}>
        <Controller
          name='phone_number'
          control={control}
          defaultValue={''}
          rules={{
            validate: {
              regex: (value: string) => {
                const pattern = /^[0]\d{9}$/;
                return pattern.test(value) || 'Must be 10 digits numbers starting with 0 with no spaces. eg 0498765437';
              },
            },
          }}
          render={({ field }) => (
            <TextField
              {...field}
              fullWidth
              variant='outlined'
              id='phone_number'
              label='Phone Number'
              disabled={formSubmitting}
              error={Boolean(errors.phone_number)}
              helperText={errors.phone_number?.message as string | undefined}
            />
          )}
        />
      </Grid>

      <Grid item xs={12}>
        <Controller
          name='state'
          control={control}
          defaultValue={''}
          rules={{ required: 'State is required' }}
          render={({ field }) => (
            <TextField
              {...field}
              fullWidth
              variant='outlined'
              id='state'
              label='State'
              disabled={formSubmitting}
              error={Boolean(errors.state)}
              helperText={errors.state?.message as string | undefined}
            />
          )}
        />
      </Grid>

      <Grid item xs={12}>
        <Controller
          name='comment'
          control={control}
          defaultValue={''}
          render={({ field }) => (
            <TextField
              {...field}
              fullWidth
              variant='outlined'
              id='comment'
              label='Comment'
              disabled={formSubmitting}
              error={Boolean(errors.comment)}
              helperText={errors.comment?.message as string | undefined}
            />
          )}
        />
      </Grid>
    </>
  );
};

export default OutcomesForm;
